import { useState } from "react";
import api from "@api";
import "./ScheduleSettings.css";

function ScheduleSettings({ id, pageId, page }) {
 const existingContent = page?.pageSettings?.content || {};

 const [scheduleFilters, setScheduleFilters] = useState({
  showDateFilter: page?.pageSettings?.content?.filters?.showDateFilter ?? true,
  showLeagueFilter: page?.pageSettings?.content?.filters?.showLeagueFilter ?? true,
  showTeamFilter: page?.pageSettings?.content?.filters?.showTeamFilter ?? true,
  showGameStatusFilter:
   page?.pageSettings?.content?.filters?.showGameStatusFilter ?? true,
 });

 const [visibleHeaders, setVisibleHeaders] = useState({
  date: page?.pageSettings?.content?.visibleHeaders?.date ?? true,
  location: page?.pageSettings?.content?.visibleHeaders?.location ?? true,
  matchup: page?.pageSettings?.content?.visibleHeaders?.matchup ?? true,
  time: page?.pageSettings?.content?.visibleHeaders?.time ?? true,
  results: page?.pageSettings?.content?.visibleHeaders?.results ?? true,
 });

 const handleSave = async () => {
  try {
   await api.put(`/api/organization-page/${id}/${pageId}`, {
    content: {
     ...existingContent,
     filters: scheduleFilters,
     visibleHeaders,
    },
   });

   alert("Settings saved.");
  } catch (err) {
   console.error("Failed to save schedule settings:", err);
   alert("Could not save settings.");
  }
 };

 return (
  <div className="schedule-settings">
   <div className="schedule-settings-card">
    <div className="schedule-settings-header">
     <h2 className="schedule-settings-title">Schedule Settings</h2>
     <p className="schedule-settings-subtext">
      Control which schedule filters and table columns appear publicly.
     </p>
    </div>

    <div className="schedule-settings-group">
     <h3 className="schedule-settings-group-title">Visible Filters</h3>
     <p className="schedule-settings-group-subtext">
      Choose which filters users can use on the public schedule page.
     </p>

     <div className="schedule-settings-options">
      <label className="schedule-settings-option">
       <div>
        <div className="schedule-settings-option-title">Show Date Filter</div>
        <div className="schedule-settings-option-subtext">
         Allow users to filter by date.
        </div>
       </div>
       <input
        type="checkbox"
        checked={scheduleFilters.showDateFilter}
        onChange={(e) =>
         setScheduleFilters((prev) => ({
          ...prev,
          showDateFilter: e.target.checked,
         }))
        }
       />
      </label>

      <label className="schedule-settings-option">
       <div>
        <div className="schedule-settings-option-title">Show League Filter</div>
        <div className="schedule-settings-option-subtext">
         Allow users to filter by league.
        </div>
       </div>
       <input
        type="checkbox"
        checked={scheduleFilters.showLeagueFilter}
        onChange={(e) =>
         setScheduleFilters((prev) => ({
          ...prev,
          showLeagueFilter: e.target.checked,
         }))
        }
       />
      </label>

      <label className="schedule-settings-option">
       <div>
        <div className="schedule-settings-option-title">Show Team Filter</div>
        <div className="schedule-settings-option-subtext">
         Allow users to filter by team.
        </div>
       </div>
       <input
        type="checkbox"
        checked={scheduleFilters.showTeamFilter}
        onChange={(e) =>
         setScheduleFilters((prev) => ({
          ...prev,
          showTeamFilter: e.target.checked,
         }))
        }
       />
      </label>

      <label className="schedule-settings-option">
       <div>
        <div className="schedule-settings-option-title">
         Show Game Status Filter
        </div>
        <div className="schedule-settings-option-subtext">
         Allow users to filter all, scheduled, or completed games.
        </div>
       </div>
       <input
        type="checkbox"
        checked={scheduleFilters.showGameStatusFilter}
        onChange={(e) =>
         setScheduleFilters((prev) => ({
          ...prev,
          showGameStatusFilter: e.target.checked,
         }))
        }
       />
      </label>
     </div>
    </div>

    <div className="schedule-settings-group">
     <h3 className="schedule-settings-group-title">Visible Table Columns</h3>
     <p className="schedule-settings-group-subtext">
      Choose which columns appear in the public schedule table.
     </p>

     <div className="schedule-settings-grid">
      {[
       { key: "date", title: "Date" },
       { key: "location", title: "Location" },
       { key: "matchup", title: "Matchup" },
       { key: "time", title: "Time" },
       { key: "results", title: "Results" },
      ].map((item) => (
       <label key={item.key} className="schedule-settings-stat-card">
        <div>
         <div className="schedule-settings-option-title">{item.title}</div>
         <div className="schedule-settings-option-subtext">
          Show {item.title.toLowerCase()} column
         </div>
        </div>

        <input
         type="checkbox"
         checked={visibleHeaders[item.key]}
         onChange={(e) =>
          setVisibleHeaders((prev) => ({
           ...prev,
           [item.key]: e.target.checked,
          }))
         }
        />
       </label>
      ))}
     </div>
    </div>

    <div className="schedule-settings-actions">
     <button
      type="button"
      className="schedule-settings-save-btn"
      onClick={handleSave}
     >
      Save Settings
     </button>
    </div>
   </div>
  </div>
 );
}

export default ScheduleSettings;